<template>
  <div id="PainterList">
    <div id="container">
      <el-card id="list">
        <div class="menu-wrap">
          <div class="icon-menu" v-for="(item, index) in menuInfo2" @click="clickMenu(index)">
            <div class="title">
              {{ $t(item.title)}}
            </div>
            <div class="img-wrap" :style="{'background-color':item.bkColor}">
              <div class="top"></div>
              <img :src=item.imgUrl />
            </div>
          </div>

          <div style="clear: both"></div>
        </div>
      </el-card>
      <div class="Hcp-footer">
        <span>
<!--          <a href="http://www.medtrum.com/index.php/abouts">{{ $t('contact us') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->

          <a :href="contactURL">{{ $t('contact us') }} </a>
              <a :href="privacyURL">|  {{ $t('Privacy Policy') }} </a>
              <a :href="termsOfUseURL">|  {{ $t('Terms of Use') }} | </a>

          {{$t('copyright')}} <br/>
          <a v-show="isZh" target=_blank href="http://beian.miit.gov.cn/"> 沪ICP备08013753号-3  </a>
          <img v-show="isZh" src="/static/beian.png" />
          <a v-show="isZh" target=_blank href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"> 沪公网安备 31011502014155号 </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import auth from '../auth/auth'
import format from '@/lib/format'
  import B64 from '../auth/base64'
  export default {
    name: 'home1',
    data () {
      return {
        isZh:false, isEU:false,
        menuInfo2:[
          {
            title:'t0805_User_Management',
            bkColor:'#0c544f',
            imgUrl:"/static/accountadmin/icon_userman.png",
            permission:'EasyPatchLogin',
          },
          {
            title:'t0805_Patient_Management',
            bkColor:'#335ea8',
            imgUrl:"/static/accountadmin/icon_patientman.png",
            permission:'EasyPatchLogin',
          },
          {
            title:'t0805_Operation_History',
            bkColor:'#ee7c58',
            imgUrl:"/static/accountadmin/icon_operationhis.png",
            permission:'EasyPatchLogin',
          },
        ],
        contactURL:'',
        privacyURL:'',
        termsOfUseURL:''
      }
    },
    beforeCreate(){
      //如果没有token的话需要重新登录
      auth.checkAuth();
      if(!auth.authenticated){
        //this.$router.push('login');
        //console.log(sessionStorage.getItem('token'));
      }
    },
    computed:{
      users(){
         return this.$store.state.users;
     },
      updateLocCode(){
        console.log('compute updateLocCode:');
        return this.$store.state.loc_code;
      }
    },
    watch:{
      updateLocCode(val){
        // this.$i18n.locale = val;
        console.log('watch updateLocCode:', val);
        let host=auth.getOuterHost();
        this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }
    },
    methods: {

      clickMenu(index) {
        console.log('clickMenu:', index);
        if (0==index) {
          this.$router.push('/HcpUserManagement')
        } else if (1==index) {
          this.$router.push('/PatientList')
        } else if (2==index) {
          this.$router.push('/HcpOperationHistory')
        }
      }
    },
    mounted:function () {
      let para = {
        page: this.page,
      };
      let win = window.innerWidth;
      this.dialogSize =(win<1500)?'small':'tiny';
      let lang  = sessionStorage.getItem('language');
      this.styleChange=(lang==='zh'||lang==='hk') ? true:false;
      // this.isEs=(lang==='es') ? true:false;
      // this.isDe=(lang==='de') ? true:false;
      // this.isIt=(lang==='it') ? true:false;
      // this.isPo=(lang==='po') ? true:false;
      // this.isPl=(lang==='pl') ? true:false;
      // this.isDu=(lang==='du') ? true:false;
      // this.isFr=(lang==='fr') ? true:false;
      // this.isSw=(lang==='sw') ? true:false;
      this.isZh = (lang==='zh')?true:false;
      // this.isCz = (lang==='cz')?true:false;
      let countryIndex=localStorage.getItem('index');
      console.info('countryIndex:'+countryIndex+','+lang+','+this.isPl);
      if (1==countryIndex || 6==countryIndex || 14==countryIndex) {
        this.isEU=false;
      }
      // auth.getUserList(this,para);
      // this.checkPrivacyVersion();
      setTimeout(()=>{
        let host=auth.getOuterHost();
        this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }, 50)
    },
  }
</script>

<style scoped>
  #PainterList{
    width:100%;
    background-color: #fff;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  #container{
    min-height:474px;
    width:62%;
    margin:0 auto;
    background:#fafbfc;
    padding-top:15px;
  }

  #list{
    margin:0 auto;
    width: 97%;
    min-height: 780px;
    background:#fff;
    box-shadow:0 3px 4px 0 rgba(175,175,175,0.50);
    border-radius:6px;
    border:none;
    position: relative;
  }
  .patientList-operate{
    height:30px;
    width:100%;
    margin-bottom: 20px;
  }
  #container .menu-wrap {
    min-height:800px;
  }

  .menu-wrap {
    width:60%;
    margin: 0 auto;
    padding-top: 50px;
  }

  .menu-wrap .icon-menu {
    width: 49%;
    float: left;
    cursor: pointer;
  }

  .menu-wrap .icon-menu:nth-child(n+3) {
    margin-top:30px;

  }

  .menu-wrap .icon-menu .title {
    border-left: 2px solid #0c544f;
    padding-left: 10px;
    font-family: SFUIText-Regular;
  }

  .menu-wrap .icon-menu .img-wrap {
    width:180px;
    height:90px;
    *background-color:#0c544f;
    border-radius:4px;
    box-shadow:5px 5px 10px rgba(0, 0, 0, 0.16);
    margin-top:20px;
    *padding-top: 15px;
  }

  .menu-wrap .icon-menu .img-wrap .top {
    height: 1px;
  }

  .menu-wrap .icon-menu .img-wrap img {
    display: block;
    height:60px;
    width: 60px;
    margin: 0 auto;
    margin-top:13px;
  }

  .patientList-operate button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    border-radius:100px;
    width: 161px;
    height: 30px;
    border: none;
    outline: none;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#ffffff;
    margin-right: 15px;
  }
  .patientList-operate button:hover{
    cursor: pointer;
  }
  .patientList-operate  .cancel{
    background: transparent;
    border:1px solid #a3a3a3;
    color: #282828;
    outline: none;
  }
  #danger{
    background-image:linear-gradient(89deg, #ff3535 1%, #ff5252 100%);
    width:100px;
  }
  #filter{
    width:100px;
  }
  .patientList-search{
    float: right;
    background:#ffffff;
    box-shadow:0 9px 26px 0 rgba(97,132,166,0.05);
    width:158px;
    height:28px;
    outline: none;
    border-radius: 100px;
    border: 1px solid #cccccc;
  }
  .patientList-search input{
    width:120px;
    height:24px;
    outline:none;
    border: none;
    display: block;
    margin-left:13px;
    margin-top:2px;
    float: left;
  }
  .patientList-search input:focus{
    color:#2aace0;
  }
  .patientList-search img{
    height:16px;
    width:16px;
    float: left;
    margin-top: 5px;
  }
  .patientList-search img:hover{
    cursor: pointer;
  }
  /*.patientList-in{*/
  /*  border:1px solid #009fdf;*/
  /*  height:28px;*/
  /*  width:156px;*/
  /*}*/
  /*.patientList-in1{*/
  /*  margin-left:-2px;*/
  /*}*/

  /*表格*/
  /*.patient-table{*/
  /*  width:100%;*/
  /*  margin:0 auto;*/
  /*  font-family:SFUIText-Regular;*/
  /*  font-size:16px;*/
  /*  color: #282828;*/
  /*  letter-spacing:-0.44px;*/
  /*  text-align:center;*/
  /*}*/
  table{
    width:100%;
    border-collapse: collapse;
  }
  .patient-table .header{
    color:#005dac;
    height:70px;
    background:#cfdff0;
    font-size:18px;
  }
  .patient-table .name{
    color:#005dac;
    width:16%;
    cursor: pointer;
    text-align: left;
    font-family:SFUIText-Regular;
    font-size:16px;
    letter-spacing:-0.39px;
    min-width: 140px;
  }
  /*.portrait{*/
  /*  border-radius:100px;*/
  /*  width:36px;*/
  /*  height:36px;*/
  /*  float: left;*/
  /*  margin-left: 10%;*/
  /*  margin-right: 10%;*/
  /*}*/
  .name p{
    margin-top: 10px;
  }
  .patient-table .gender{
    width:10%;
  }
  .patient-table .small{
    width:10%;
  }
  .patient-table .diabetes-date{
    width:15%;
  }
  tr{
    height: 60px;
    font-size:16px;
    letter-spacing:-0.39px;
    text-align:center;
  }
  /*.checkbox{*/
  /*  width:7%;*/
  /*}*/
  /*.even{*/
  /*  background:#ebeef1;*/
  /*}*/
  table input{
    width:16px;
    height:16px;
  }
  .checkbox22{
    opacity: 0;
  }
  table label{
    display: inline-block;
    width:17px;
    height:17px;
    background: url("../assets/checkbox.png") left 1px no-repeat;
    cursor: pointer;
  }
  .checked{
    background: url("../assets/Select.png") left 0 no-repeat;
  }
  .name .filterResult{
   color: #e00;
  }

 /*分页*/
  .patientList-block{
    margin-top:15px;
    height:20px;
    width: 208px;
    letter-spacing:-0.44px;
    position: absolute;
    bottom: 15px;
  }
  .patientList-block img{
    cursor: pointer;
    float: left;
  }
  .patientList-block span{
    float: left;
    display: block;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    text-align:left;
    margin: -2px 20px 0;
  }
  .patientList-block input{
    font-family:SFUIText-Regular;
    font-size:18px;
    height:18px;
    width:36px;
    margin-right: 20px;
    text-align: center;
  }
  .patientList-block .click1{
    opacity: 0.3;
    cursor:auto;
  }

  .Hcp-footer{
    font-family:HelveticaNeue;
    font-size:14px;
    color:rgba(120,120,120,0.90);
    letter-spacing:-0.34px;
    text-align:center;
    margin-top: 13px;
  }
  .Hcp-footer a{
    color:rgba(120,120,120,0.90);
    text-decoration: none;
  }
  .Hcp-footer a:hover{
    color:#0090D3;
  }


  /*dialog对话框*/
  #dialog-form{
    font-family:SFUIText-Regular;
  }
  .patientList-dialog-title{
    float: left;
    background-image:linear-gradient(90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .patientList-dialog-title span{
    margin-left: 42px;
  }
  .patientList-dialog-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }
  /*.dialog-body{*/
  /*  width:100%;*/
  /*  margin-top: 25px;*/
  /*}*/
  /*.lab-group1,.lab-group2,.lab-group3{*/
  /*  width: 100%;*/
  /*  height:45px;*/
  /*  margin-left:17px;*/
  /*}*/
  /*.lab-group2{*/
  /*  width: 86%;*/
  /*}*/
  /*.patientList-small-hr{*/
  /*  background:#dedede;*/
  /*  width:90%;*/
  /*  height:1px;*/
  /*  margin:10px 0 10px 20px;*/
  /*  border:none;*/
  /*  clear: both;*/
  /*}*/
  /*!*最后一栏标签数太多，水平线间距设置大点*!*/
  /*.patientList-spe1-hr{*/
  /*  margin-top:40px;*/
  /*}*/
  #dialog-form label{
    display: block;
    float: left;
    width:65px;
    height:24px;
    margin-right:8px;
    margin-left: 5px;
    margin-top:10px;
    line-height: 24px;
    font-size: 16px;
    text-align: left;
    border-right:1px solid #ccc;
    color:#282828;
    letter-spacing:-0.39px;
  }
  #dialog-form .de3{
    margin-left: -9px;
    width: 80px;
  }
  /*.patientList-line{*/
  /*  float:left;*/
  /*  margin-top:10px;*/
  /*  padding-bottom:1px;*/
  /*  border-right:1px solid #ccc ;*/
  /*}*/
  /*.label1{*/
  /*  float:left;*/
  /*  width:50px;*/
  /*  height:24px;*/
  /*  line-height:24px;*/
  /*  font-size: 14px;*/
  /*  color:#282828;*/
  /*  letter-spacing:-0.34px;*/
  /*  cursor: pointer;*/
  /*  margin-right: 10px;*/
  /*}*/
  /*.ZH1{*/
  /*  margin-right: 5px;*/
  /*}*/
  /*.filter-label{*/
  /*  float:left;*/
  /*  width:70px;*/
  /*  height:24px;*/
  /*  line-height:24px;*/
  /*  font-size: 14px;*/
  /*  margin-top:10px;*/
  /*  margin-left: 5px;*/
  /*  color:#282828;*/
  /*  letter-spacing:-0.34px;*/
  /*  cursor: pointer;*/
  /*}*/
  /*.long-lab{*/
  /*  width:96px;*/
  /*}*/
  /*.long-lab1{*/
  /*  width:116px;*/
  /*  margin-right: 10px;*/
  /*}*/
  /*.small_lab{*/
  /*  margin-bottom: 10px;*/
  /*}*/
  .filter-label span{
    display: block;
    float: left;
    margin-left: 10px;
  }
  .ZH3{
    padding-left: 10px;
  }
  .ZH4{
    width:60px;
  }
  .label1 span{
    display: block;
    float: left;
    margin-left: 15px;
  }
  .label1 .ZH{
    margin-left:6px;
  }
  .filter-label img,.label1 img{
    float:right;
    margin:8px 4px 0 0;
  }
  /*.patientList-type{*/
  /*  float: left;*/
  /*  width:60%;*/
  /*}*/
  /*.choose{*/
  /*  height:22px;*/
  /*  width:48px;*/
  /*  border:1px solid #979797;*/
  /*  border-radius:4px;*/
  /*}*/
  /*.choose1{*/
  /*  height:22px;*/
  /*  width:68px;*/
  /*  border:1px solid #979797;*/
  /*  border-radius:4px;*/
  /*}*/
  /*.choose2{*/
  /*  height:22px;*/
  /*  width:94px;*/
  /*  border:1px solid #979797;*/
  /*  border-radius:4px;*/
  /*}*/
  /*.choose3{*/
  /*  height:22px;*/
  /*  width:114px;*/
  /*  border:1px solid #979797;*/
  /*  border-radius:4px;*/
  /*}*/
  /*.choose4{*/
  /*  height:22px;*/
  /*  width:150px;*/
  /*  border:1px solid #979797;*/
  /*  border-radius:4px;*/
  /*}*/
  /*.de17{*/
  /*  width:190px;*/
  /*}*/
  /*.de18{*/
  /*  width:200px;*/
  /*}*/
  /*.it18{*/
  /*  width:185px;*/
  /*}*/
  /*.es18{*/
  /*  width:215px;*/
  /*}*/
  /*.po17{*/
  /*  width:180px;*/
  /*}*/
  /*.po19{*/
  /*  width:180px;*/
  /*}*/
  /*.po18{*/
  /*  width:225px;*/
  /*}*/


  /*.es1{*/
  /*  width:118px;*/
  /*}*/
  /*.es2{*/
  /*  width:60px;*/
  /*}*/
  /*.es3{*/
  /*  width:80px;*/
  /*}*/
  /*.de1{*/
  /*  width:128px;*/
  /*}*/
  /*.de2{*/
  /*  width:182px;*/
  /*}*/
  /*.it6{*/
  /*  width: 105px;*/
  /*}*/
  /*.de4{*/
  /*  width:65px;*/
  /*}*/
  /*.de5{*/
  /*  width:55px;*/
  /*}*/
  /*.de6{*/
  /*  width:85px;*/
  /*}*/
  /*.po2{*/
  /*  width:70px;*/
  /*}*/
  /*.po3{*/
  /*  width:125px;*/
  /*}*/
  /*.po4{*/
  /*  width:85px;*/
  /*}*/
  /*.po5{*/
  /*  width:115px;*/
  /*}*/
  /*.pl1{*/
  /*  width:155px;*/
  /*}*/
  /*.pl2{*/
  /*  width:70px;*/
  /*}*/
  /*.pl3{*/
  /*  width:112px;*/
  /*}*/
  /*.pl4{*/
  /*  width:90px;*/
  /*}*/
  /*.ZH2{*/
  /*  width:180px;*/
  /*  margin-left:0;*/
  /*}*/
  .ZH2 span{
    padding-left: 0;
  }
  /*.ZH10 {*/
  /*  margin-left:-8px;*/
  /*}*/
  /*.ZH5{*/
  /*  width:94px;*/
  /*}*/
  /*.ZH8{*/
  /*  width: 80px;*/
  /*  padding-left: 13px;*/
  /*}*/
  /*.du2{*/
  /*  width:55px;*/
  /*}*/
  /*.du3{*/
  /*  width:130px;*/
  /*}*/
  /*.du4{*/
  /*  width:125px;*/
  /*}*/

  /*.fr1{*/
  /*  width: 100px;*/
  /*}*/
  /*.fr2{*/
  /*  width: 80px;*/
  /*}*/
  /*.sw1{*/
  /*  width: 90px;*/
  /*}*/
  /*.sw2{*/
  /*  width: 190px;*/
  /*}*/
  /*.cz1{*/
  /*  width: 95px;*/
  /*}*/
  /*.cz2{*/
  /*  width: 120px;*/
  /*}*/
  /*.cz3{*/
  /*  width: 160px;*/
  /*}*/
  /*.patientList-dialog-footer{*/
  /*  width:65%;*/
  /*  margin-top:-30px;*/
  /*}*/
  .patientList-dialog-footer button,#dialog-form2 button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:100px;
    width:150px;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }

  #dialog-form2 .cancelButton{
    background: transparent;
    border:1px solid #a3a3a3;
    color: #282828;
    outline: none;
    margin-bottom: 20px;
    margin-top: 10px;
  }
  #dialog-form2 .dialog-body{
    font-family:SFUIText-Regular;
    font-size:15px;
    color:#ffffff;
    letter-spacing:-0.36px;
    text-align:center;
  }
  /*.new,.find{*/
  /*  float: left;*/
  /*  width:150px;*/
  /*  margin-bottom: 34px;*/
  /*  margin-top: 35px;*/
  /*  margin-left: 10%;*/
  /*}*/
  /*.find{*/
  /*  float: right;*/
  /*  margin-right: 10%;*/
  /*  margin-left: 0;*/
  /*}*/
  .new img,.find img{
    height:60px;
    width:60px;
    display: block;
    margin-left: 45px;
    margin-bottom: 30px;
  }

  /*筛选提示框*/
  /*.patientList-label-tooltip{*/
  /*  width:300px;*/
  /*  height:135px;*/
  /*  background:rgba(255,255,255,0.97);*/
  /*  *box-shadow:0 2px 4px 0 rgba(30,30,30,0.50);*/
  /*  border-radius:5px;*/
  /*  font-family:SFUIText-Regular;*/
  /*  font-size:16px;*/
  /*  color:#282828;*/
  /*  letter-spacing:-0.39px;*/
  /*  text-align:left;*/
  /*}*/
  /*.patientList-title{*/
  /*  margin:15px 0 10px 10px;*/
  /*  border-left: 2px solid #005dac;*/
  /*}*/
  .patientList-title span{
    margin-left:13px;
  }
  /*.patientList-small2-hr{*/
  /*  background:#e6e8ea;*/
  /*  width:260px;*/
  /*  height:1px;*/
  /*  margin:0 auto;*/
  /*  border:none;*/
  /*}*/
  /*.label-group{*/
  /*  width:246px;*/
  /*  margin: 0 auto;*/
  /*}*/
  .label-group .filter-label{
    margin-right: 6px;
  }

  /*.el-table-column{*/
  /*  border:none;*/
  /*  color:#005dac;*/
  /*}*/
  /*.dialog-title {*/
  /*  margin-bottom: 30px;*/
  /*  font-size:18px;*/
  /*  font-weight: bold;*/
  /*}*/

  /*.dialog-footer{*/
  /*  margin:35px auto 0px;*/
  /*  width:90%;*/
  /*}*/
  .dialog-footer button{
    *background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:3px;
    width:20%;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }

  .dialog-footer .deny {
    float:left;
    background-color:#888;
  }

  .dialog-footer .agree {
    float:right;
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
  }
  @media screen and (max-width: 1500px){
    #container{
      width:92%;
    }
    .ZH9{
      width: 80px;
      padding-left: 13px;
    }
  }
  @media screen and (min-height: 950px){
    #container{
      min-height:904px;
    }
  }
</style>



// WEBPACK FOOTER //
// HcpMenu.vue?40888fe6